import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Bar } from "react-chartjs-2";
import CountryList from "../CountryList";
import { googleApi } from "../../services/api";
import { FaGlobeAmericas, FaSearch } from "react-icons/fa";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import {Spinner} from "react-bootstrap";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

const PackageForm = () => {
  const [packageName, setPackageName] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false); // New loading state

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading to true

    const dataToSend = {
      package_name: packageName,
      country: countryCode,
    };

    try {
      const res = await googleApi.post("get_localized_app_data/", dataToSend);
      setResponse(res.data);
    } catch (error) {
      console.error("Error:", error);
      setResponse("API error occurred");
    } finally {
      setLoading(false); // Set loading to false
    }
  };

  // Chart Data for Localization
  const ratingsChartData = {
    labels: ["Ratings"],
    datasets: [
      {
        label: "Ratings",
        data: [response?.localized_data?.ratings || 0],
        backgroundColor: "rgba(153, 102, 255, 0.6)",
      },
    ],
  };

  const scoreChartData = {
    labels: ["Score"],
    datasets: [
      {
        label: "Score",
        data: [response?.localized_data?.score || 0],
        backgroundColor: "rgba(255, 159, 64, 0.6)",
      },
    ],
  };

  // Chart Data for ASO Audit
  const averageRatingChartData = {
    labels: ["Average Rating"],
    datasets: [
      {
        label: "Average Rating",
        data: [response?.aso_audit?.rating_analysis?.average_rating || 0],
        backgroundColor: "rgba(54, 162, 235, 0.6)",
      },
    ],
  };

  const ratingCountChartData = {
    labels: ["Rating Count"],
    datasets: [
      {
        label: "Rating Count",
        data: [response?.aso_audit?.rating_analysis?.rating_count || 0],
        backgroundColor: "rgba(255, 206, 86, 0.6)",
      },
    ],
  };

  const totalScreenshotsChartData = {
    labels: ["Total Screenshots"],
    datasets: [
      {
        label: "Total Screenshots",
        data: [response?.aso_audit?.screenshot_quality?.total_screenshots || 0],
        backgroundColor: "rgba(255, 99, 132, 0.6)",
      },
    ],
  };

  const stopwords = new Set([
    "a",
    "an",
    "the",
    "i",
    "me",
    "my",
    "mine",
    "you",
    "your",
    "yours",
    "he",
    "him",
    "his",
    "she",
    "her",
    "hers",
    "it",
    "its",
    "we",
    "us",
    "our",
    "ours",
    "they",
    "them",
    "their",
    "theirs",
    "who",
    "whom",
    "whose",
    "and",
    "but",
    "or",
    "nor",
    "for",
    "so",
    "yet",
    "either",
    "neither",
    "both",
    "than",
    "that",
    "as",
    "while",
    "although",
    "because",
    "if",
    "unless",
    "whether",
    "in",
    "on",
    "at",
    "to",
    "of",
    "from",
    "by",
    "about",
    "as",
    "with",
    "between",
    "over",
    "under",
    "above",
    "below",
    "across",
    "through",
    "during",
    "before",
    "after",
    "against",
    "without",
    "within",
    "is",
    "are",
    "was",
    "were",
    "be",
    "been",
    "being",
    "have",
    "has",
    "had",
    "do",
    "does",
    "did",
    "will",
    "shall",
    "can",
    "could",
    "may",
    "might",
    "must",
    "ought",
    "need",
    "very",
    "too",
    "just",
    "only",
    "also",
    "even",
    "still",
    "yet",
    "then",
    "now",
    "here",
    "there",
    "back",
    "forward",
    "further",
    "more",
    "less",
    "once",
    "again",
    "oh",
    "ah",
    "uh",
    "hmm",
    "wow",
    "yay",
    "oops",
    "hey",
    "alas",
    "some",
    "any",
    "no",
    "none",
    "all",
    "most",
    "few",
    "several",
    "many",
    "much",
    "each",
    "every",
    "either",
    "neither",
    "a lot",
    "this",
    "that",
    "these",
    "those",
    "which",
    "what",
    "where",
    "when",
    "how",
    "why",
    "what",
    "how",
    "whoever",
    "whatever",
    "whenever",
    "wherever",
    "whichever",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
    "twenty",
    "there",
    "here",
    "back",
    "up",
    "down",
    "out",
    "in",
    "off",
    "over",
    "under",
    "along",
    "despite",
    "since",
    "let",
    "us",
    "let’s",
    "got",
    "get",
    "gotta",
    "gonna",
    "wanna",
    "have to",
    "used to",
    "be able to",
    "he's",
    "she's",
    "it's",
    "they're",
    "we're",
    "you're",
    "who's",
    "what's",
    "where's",
    "when's",
    "how's",
    "let's",
    "ain't",
    "won't",
    "can't",
    "doesn't",
    "don't",
    "didn't",
    "even",
    "just",
    "only",
    "merely",
    "simply",
    "actually",
    "really",
    "truly",
    "especially",
    "particularly",
  ]);

  function removeStopwords(keyword) {
    // Remove numbers, links, and tags
    let cleanedKeyword = keyword
      .replace(/(\d+|\bhttps?:\/\/\S+\b|<[^>]*>|[^\p{L}\p{N}\s])/giu, "")
      .trim();

    // Filter out stopwords
    return stopwords.has(cleanedKeyword.toLowerCase()) ? "" : cleanedKeyword;
  }

  return (
    <div className="container mt-4">
      <div className="bg-white rounded-xl shadow-md p-6 mb-8 border border-gray-100">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
          <FaGlobeAmericas className="mr-3 text-green-500" />
          Localized ASO Insights
        </h2>
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-end">
                <div className="md:col-span-5">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Enter Package Name</label>
                    <input
                    type="text"
                    className="w-full bg-white border border-gray-300 rounded-md py-2 px-3 text-sm text-gray-700 placeholder-gray-400 shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition duration-200"
                    value={packageName}
                    onChange={(e) => setPackageName(e.target.value)}
                    placeholder="e.g. com.facebook.katana"
                    required
                    />
                </div>
                <div className="md:col-span-5">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Select Country</label>
                    <CountryList
                    onSelect={(selectedCountry) => setCountryCode(selectedCountry)}
                    />
                </div>
                <div className="md:col-span-2">
                    <button
                    type="submit"
                    className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-md shadow transition duration-200 flex items-center justify-center"
                    >
                    <FaSearch className="mr-2" />
                    Get Insights
                    </button>
                </div>
            </div>
        </form>
      </div>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "300px" }}
        >
          <Spinner animation="border" role="status" />
          <span className="ms-2">Loading Please Wait...</span>
        </div>
      )}

      {/* Display the API response in table format */}
      {response && (
        <div className="mt-4">
          {response.localized_data ? (
            <div style={{ fontSize: "0.7rem" }}>
              <h4 className="mt-3 mb-3">Localized Data:</h4>
              <table className="table table-bordered table-striped">
                <thead className="table-light">
                  <tr>
                    <th>Field</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Title</td>
                    <td>{response.localized_data.title}</td>
                  </tr>
                  <tr>
                    <td>Description</td>
                    <td>{response.localized_data.description}</td>
                  </tr>
                  <tr>
                    <td>Summary</td>
                    <td>{response.localized_data.summary}</td>
                  </tr>
                  <tr>
                    <td>Developer</td>
                    <td>{response.localized_data.developer}</td>
                  </tr>
                  <tr>
                    <td>Updated</td>
                    <td>
                      {new Date(
                        response.localized_data.updated * 1000
                      ).toLocaleString()}
                    </td>
                  </tr>
                  <tr>
                    <td>Version</td>
                    <td>{response.localized_data.version}</td>
                  </tr>
                  <tr>
                    <td>Currency</td>
                    <td>{response.localized_data.currency}</td>
                  </tr>
                  <tr>
                    <td>Price</td>
                    <td>{response.localized_data.price}</td>
                  </tr>
                </tbody>
              </table>

              {/* Display the charts for localization */}
              <div className="row mt-4" style={{ fontSize: "0.7rem" }}>
                <div className="col-md-6">
                  <h5>Localization Data - Ratings Bar Chart</h5>
                  <Bar data={ratingsChartData} options={{ responsive: true }} />
                </div>
                <div className="col-md-6">
                  <h5>Localization Data - Score Bar Chart</h5>
                  <Bar data={scoreChartData} options={{ responsive: true }} />
                </div>
              </div>

              {/* Display screenshots */}
              {response.localized_data.screenshots &&
                response.localized_data.screenshots.length > 0 && (
                  <div className="mt-4">
                    <h5 className="mb-3">Screenshots:</h5>
                    <div className="row">
                      {response.localized_data.screenshots.map(
                        (screenshot, index) => (
                          <div className="col-md-4 mb-3" key={index}>
                            <img
                              src={screenshot}
                              alt={`Screenshot ${index + 1}`}
                              className="img-fluid"
                              style={{ borderRadius: "8px" }}
                            />
                          </div>
                        )
                      )}
                    </div>
                  </div>
                )}
            </div>
          ) : (
            <p>No localized data available.</p>
          )}

          {/* ASO Audit Data */}
          {response.aso_audit && (
            <div>
              <h4 className="mt-4 mb-3" style={{ fontSize: "0.7rem" }}>
                ASO Audit Data:
              </h4>
              <table
                className="table table-bordered table-striped"
                style={{ fontSize: "0.7rem" }}
              >
                <thead className="table-light">
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#f5f5f5",
                        textAlign: "center",
                      }}
                    >
                      Field
                    </th>
                    <th
                      style={{
                        backgroundColor: "#f5f5f5",
                        textAlign: "center",
                      }}
                    >
                      Value
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ color: "black" }}>Keywords Found</td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "0.5rem",
                          maxHeight: "150px",
                          overflowY: "auto",
                          padding: "0.5rem",
                        }}
                      >
                        {response.aso_audit.keywords.keywords_found.map(
                          (keyword, index) => {
                            const cleanedKeyword = removeStopwords(keyword);
                            return cleanedKeyword ? (
                              <span
                                key={index}
                                style={{
                                  display: "inline-block",
                                  padding: "0.3rem 0.6rem",
                                  backgroundColor: "#4872e5",
                                  color: "#fff",
                                  borderRadius: "12px",
                                  fontSize: "0.7rem",
                                  textAlign: "center",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {cleanedKeyword}
                              </span>
                            ) : null; // Only show if not empty
                          }
                        )}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ color: "black" }}>Keyword Count</td>
                    <td>{response.aso_audit.keywords.keyword_count}</td>
                  </tr>
                  <tr>
                    <td style={{ color: "black" }}>Average Rating</td>
                    <td>{response.aso_audit.rating_analysis.average_rating}</td>
                  </tr>
                  <tr>
                    <td style={{ color: "black" }}>Rating Count</td>
                    <td>{response.aso_audit.rating_analysis.rating_count}</td>
                  </tr>
                  <tr>
                    <td style={{ color: "black" }}>Total Screenshots</td>
                    <td>
                      {response.aso_audit.screenshot_quality.total_screenshots}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ color: "black" }}>High Quality Screenshots</td>
                    <td>
                      {response.aso_audit.screenshot_quality.high_quality
                        ? "Yes"
                        : "No"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ color: "black" }}>Low Quality Screenshots</td>
                    <td>
                      {response.aso_audit.screenshot_quality.low_quality
                        ? "Yes"
                        : "No"}
                    </td>
                  </tr>
                </tbody>
              </table>
              {/* Display the charts for ASO audit */}
              <div className="row mt-4" style={{ fontSize: "0.7rem" }}>
                <div className="col-md-6">
                  <h5>ASO Audit - Average Rating Bar Chart</h5>
                  <Bar
                    data={averageRatingChartData}
                    options={{ responsive: true }}
                  />
                </div>
                <div className="col-md-6">
                  <h5>ASO Audit - Rating Count Bar Chart</h5>
                  <Bar
                    data={ratingCountChartData}
                    options={{ responsive: true }}
                  />
                </div>
                <div className="col-md-6 mt-4">
                  <h5>ASO Audit - Total Screenshots Bar Chart</h5>
                  <Bar
                    data={totalScreenshotsChartData}
                    options={{ responsive: true }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PackageForm;
